import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
} from "../services/types/ComponentTypes";

export const screen_2236_consolidated_invoice: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Consolidated Invoice",
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "hsl(var(--bg-white))",
          padding: 20,
          borderRadius: 4,
        },
        childComponents: [
          {
            componentType: LayoutTypes.GROUP,
            style: {
              direction: FlexDirection.ROW,
              justifyContent: "flex-end",
              marginBottom: 16,
            },
            childComponents: [
              {
                componentType: ComponentType.BUTTON,
                name: "consolidated_invoice_print",
                Label: "Complete Print",
                onPressAction: "consolidated_invoice_print",
                style: {
                  backgroundColor: "var(--primary-green)",
                  textColor: "#FFFFFF",
                  padding: 12,
                  borderRadius: 6,
                  fontSize: 14,
                  fontWeight: "500",
                },
              },
            ],
          },
          {
            componentType: ComponentType.SEARCHABLE_DROPDOWN,
            name: "drp_customer",
            Label: "Customer name",
            placeholder: "Select customer",
            required: true,
            LookupName: "customers",
            Json_Attribute: "customer_id",
            BindValue: "drp_customer",
          },
          {
            componentType: ComponentType.SUMMARY_LIST,
            DisplayName: "Open Job Cards",
            Name: "consolidated_invoice_open_jobcards",
            apiname: "consolidated_invoice_open_jobcards",
            titleValue: "name",
            parentField: "drp_customer",
            enableRowSelection: true,
            rowSelectionIdField: "id",
            rowSelectionFormField: "consolidated_selected_jobcard_ids",
            fields: [
              {
                IncludeLabel: true,
                Label: "Jobcard / Vehicle",
                BindValue: "jobcard_vehicle_detail",
                Json_Attribute: "jobcard_vehicle_detail",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: true,
                valueFormat: "multiline",
                StickyColumn: "left",
                StickyWidth: "260px",
              },
              {
                IncludeLabel: true,
                Label: "Job date",
                BindValue: "job_date",
                Json_Attribute: "job_date",
                componentType: ComponentType.DATE_FIELD,
                showInSummary: true,
              },
              {
                IncludeLabel: true,
                Label: "Reg No.",
                BindValue: "reg_no",
                Json_Attribute: "reg_no",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
              },
              {
                IncludeLabel: true,
                Label: "Vehicle make",
                BindValue: "vehicle_make",
                Json_Attribute: "vehicle_make",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
              },
              {
                IncludeLabel: true,
                Label: "Net amount",
                BindValue: "gross_net_amount",
                Json_Attribute: "gross_net_amount",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: true,
              },
              {
                IncludeLabel: true,
                Label: "Invoice status",
                BindValue: "invoice_status",
                Json_Attribute: "invoice_status",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: true,
              },
            ],
          },
        ],
      },
    ],
  },
];
